import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";

const Tooltip = styled.div`
  position: absolute;
  display: none;
  top: ${(props) => (props.tooltipPosition.x === "top" ? "-155px" : "82px")};
  left: ${(props) =>
    props.tooltipPosition.y === "left" ? "0%" : props.tooltipPosition.y === "right" ? "90%" : "50%"}; /* 중앙 정렬 */
  transform: ${(props) =>
    props.tooltipPosition.y === "left"
      ? "translateX(0%)"
      : props.tooltipPosition.y === "right"
      ? "translateX(-100%)"
      : "translateX(-50%)"}; /* 중앙에서 왼쪽으로 50% 이동 */
  z-index: 99;
  width: auto;
  box-sizing: border-box;
  .speech-bubble {
    display: flex;
    position: relative;
    background: #fafafa;
    border-radius: 0.4em;
    padding: 16px;
    box-shadow: 0px 0px 16px -2px #e1e1e1;
    > img {
      width: 80px;
      height: 100px;
      border-radius: 0;
      margin-right: 8px;
      box-shadow: none;
    }
    > div:last-child {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      h3,
      h4,
      div {
        font-size: 13px;
        margin: 0;
        white-space: nowrap;
      }
    }
  }

  .speech-bubble:after {
    content: "";
    position: absolute;
    ${(props) => (props.tooltipPosition.x === "top" ? "bottom" : "top")}: 0;
    bottom: 0;
    left: ${(props) =>
      props.tooltipPosition.y === "left" ? "10%" : props.tooltipPosition.y === "right" ? "90%" : "50%"};
    width: 0;
    height: 0;
    border: 20px solid transparent;
    /* ${(props) => (props.tooltipPosition.x === "top" ? "border-top-color" : "border-bottom-color")}: '#fafafa'; */
    ${(props) => (props.tooltipPosition.x === "top" ? "border-top-color" : "border-bottom-color")}: #fafafa;
    ${(props) => (props.tooltipPosition.x === "top" ? "border-bottom" : "border-top")}: 0;
    margin-left: -20px;
    ${(props) => (props.tooltipPosition.x === "top" ? "margin-bottom" : "margin-top")}: -20px;
  }
`;

const ProfileCard = ({ tooltipPosition, userInfo }) => {
  const formatPhoneNumber = (mob) => {
    if (mob.length === 7) {
      return mob.replace(/(\d{3})(\d{4})$/, "010-$1-$2");
    } else if (mob.length === 8) {
      return mob.replace(/(\d{4})(\d{4})$/, "010-$1-$2");
    }
    return mob;
  };

  return (
    <Tooltip tooltipPosition={tooltipPosition}>
      <div className="speech-bubble">
        <img
          src={`${process.env.REACT_APP_BECCO_API_URL}/api/employee/image/${userInfo.employeeNo}`}
          alt={`profile of ${userInfo.enName}`}
        />
        <div>
          <h3>{userInfo.name}</h3>
          <h4>{userInfo.enName}</h4>
          <div>
            {userInfo.jd} ({userInfo.div})
          </div>
          <div>
            <FontAwesomeIcon icon={faPhone} style={{ marginRight: "5px" }} />
            {formatPhoneNumber(userInfo.mob)}
          </div>
          <div>
            <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: "5px" }} />
            {userInfo.email}
          </div>
        </div>
      </div>
    </Tooltip>
  );
};

export default ProfileCard;
